<template>
 <div class="block-format d-flex flex-wrap">
    <div class="block-format__format-btn mr-4 mt-2 px-2 d-flex align-items-center justify-content-center" v-for="count in countButtons"
      :key="count" @click="selectCount(count)"
      :class="{selected: selectedCount === count && count != inputCount}">
      {{count}}
    </div>
    <div class="block-format__format-input d-flex align-items-center" v-show="isCountInputEnable">
      <input placeholder="количество" type="text" autocomplete="off" class="form-control" v-model="inputCount" @blur="modifyInputCount">
    </div>
  </div>
</template>
<script>

export default {
  name: 'CalculatePriceBlockFormat',
  components: {},
  props: {
    data: {
      default: () => {
        return []
      }
    }
  },
  data: () => {
    return {
      selectedCount: null,
      inputCount: null
    }
  },
  methods: {
    selectCount (count) {
      if (count === this.selectedCount && count !== this.inputCount) {
        this.inputCount = null
        this.selectedCount = null
      } else {
        this.inputCount = null
        this.selectedCount = count
      }
      this.$emit('selectOperationCounter', this.selectedCount)
    },
    modifyInputCount () {
      this.inputCount = this.inputCount.replace(',', '.')
    }
  },
  computed: {
    countButtons () {
      return this.data.filter(x => !!x)
    },
    isCountInputEnable () {
      return this.data.some(x => !x)
    }
  },
  watch: {
    inputCount: function (newValue) {
      if (newValue) {
        this.selectedCount = newValue
      }
      if (newValue === '') {
        this.selectedCount = null
      }
      this.$emit('selectOperationCounter', this.selectedCount)
    }
  },
  created () {
    this.$emit('selectOperationCounter', this.selectedCount)
  }
}
</script>

<style lang="scss" scoped>
.block-format {
  &__format-btn {
    cursor: pointer;
    position: relative;
    height: 38px;
    min-width: 80px;
    border-radius: 4px;
    box-shadow: inset 0 1px 0 rgba(40, 189, 139, 0.15);
    background-color: #e9f8f3;
    color: #28bd8b;
    max-width: 400px;

    &.selected {
      background-color: #28bd8b;
      color: #fff;
    }
  }

  &__format-input {
    max-width: 200px;
  }
}
</style>
